import { Feature } from "@omni/types/api/product/bff/shared/feature.model";
import { cn } from "@omni/utils/styles";

import { Anchor } from "@/components/General/Anchor/anchor.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { renderFeature } from "../ProductTile/components/description/description.helpers";

export type KeyFeaturesProps = {
    features: Array<Feature>;
};

const KeyFeatures = ({ features }: KeyFeaturesProps) => {
    const { t } = useGranite();

    const title = t("productDetail.title.keyFeatures");

    const keyFeatures = features.filter((f) => !!f.coreFeature);

    if (keyFeatures.length === 0) return null;

    return (
        <>
            {!!title && <p className={"heading-5"}>{title}</p>}
            <ul
                className={cn("tw:list-none tw:p0")}
                data-test="keyFeatures-list"
            >
                {keyFeatures.slice(0, 4).map((keyFeature) => (
                    <li
                        className={cn(
                            "tw:border-t tw:border-t-solid tw:border-t-grey-light tw:flex tw:justify-between tw:py-3 tw:last:border-b tw:last:border-b-solid tw:last:border-b-grey-light"
                        )}
                        data-test={`keyFeatures-list-item-${keyFeature.name}`}
                        key={`keyFeatures-list-item-${keyFeature.name}`}
                    >
                        <span
                            data-test={`keyFeatures-list-item-${keyFeature.name}-name`}
                        >
                            {keyFeature.name}
                        </span>
                        <span
                            className={cn("tw:text-right")}
                            data-test={`keyFeatures-list-item-${keyFeature.name}-value`}
                        >
                            {renderFeature({
                                formattedValues: keyFeature.featureValues.map(
                                    (fv) => fv.formattedValue || ""
                                ),
                                unitName: keyFeature.unit?.name
                            })}
                        </span>
                    </li>
                ))}
            </ul>
            <Anchor
                href="#specs"
                color={"link"}
                className={cn("tw:hidden tw:lg:inline-block tw:p-0")}
                data-test={"keyFeatures-link"}
            >
                {t("productDetail.link.showMoreFeatures")}
                <i className={cn("las la-angle-right la-lg")}></i>
            </Anchor>
        </>
    );
};

export { KeyFeatures };
